import { render, staticRenderFns } from "./MleCountryOfOriginSummary.vue?vue&type=template&id=0624263f"
import script from "./MleCountryOfOriginSummary.ts?vue&type=script&lang=ts&external"
export * from "./MleCountryOfOriginSummary.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports